const isHmg = () => {
  return window.location.hostname.match(/\.hmg\./);
}
export default isHmg;
